import * as React from "react";
import { ForwardedRef, forwardRef } from "react";
import { InfoMessageConfig, InfoType } from "../../driver/info/infoMessages";
import { InfoElement } from "../Questions/infoElement";
import { DisclaimerElement } from "../Questions/diclaimerElement";
import { EmergencyElement } from "../emergencyElement";
import { ExchangeInfo } from "../../driver/types/driverTypes";
import { useTranslate } from "../../hooks/useTranslate";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface InfoMessageViewProps {
  index: number;
  info: ExchangeInfo;
  onIndexConfirm: (index) => void;
  wasLastInfoApproved: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InfoMessageView = forwardRef(
  (
    { wasLastInfoApproved, index, info, ...props }: InfoMessageViewProps,
    ref: ForwardedRef<any>,
  ) => {
    const { translate } = useTranslate();

    const continueHandler = () => {
      props.onIndexConfirm(index);
    };

    const onContinue = info.confirm ? continueHandler : null;

    const text = info.infoText;

    const continueLabel = InfoMessageConfig[info.id]?.buttonText
      ? translate(InfoMessageConfig[info.id]?.buttonText)
      : translate("OK");

    switch (InfoMessageConfig[info.id]?.type) {
      case InfoType.INFO:
        return (
          <InfoElement
            ref={ref}
            key={"info" + index}
            noConfirm={!info.confirm}
            infoText={text}
            onContinue={onContinue}
            continueLabel={continueLabel}
            answered={wasLastInfoApproved}
          />
        );
      case InfoType.DISCLAIMER:
        return (
          <DisclaimerElement
            ref={ref}
            key={"disclaimer" + index}
            infoText={text}
            onContinue={onContinue}
            continueLabel={continueLabel}
            answered={wasLastInfoApproved}
          />
        );
      case InfoType.EMERGENCY:
        return (
          <EmergencyElement
            ref={ref}
            key={"emergency" + index}
            onContinue={onContinue}
            answered={wasLastInfoApproved}
          />
        );
      default:
        return (
          <InfoElement
            ref={ref}
            key={"info" + index}
            noConfirm={!info.confirm}
            infoText={text}
            onContinue={onContinue}
            continueLabel={continueLabel}
            answered={wasLastInfoApproved}
          />
        );
    }
  },
);
